import { useState } from "preact/hooks";
import { GET, GET_COUNT_RESERVATION } from "../../../services";

export const useGetCountReversation = () => {
  const [countComplete, setCountComplete] = useState(0);
  const [countNotConfirmChange, setNotConfirmChange] = useState(0);
  const [countWaitInvoice, setWaitInvoice] = useState(0);
  const [countWaitSaleOrder, setWaitSaleOrder] = useState(0);
  const [countDeviceSaleOrder, setCountDeviceSaleOrder] = useState(0)

  const onFetchCountReservation = async () => {
    try {
      const res = await GET(GET_COUNT_RESERVATION);
      const { complete, notConfirmChange, waitInvoice, waitSaleOrder, countDeviceSaleOrder: cd } =
        res.result.count;
      setCountComplete(complete);
      setNotConfirmChange(notConfirmChange);
      setWaitInvoice(waitInvoice);
      setWaitSaleOrder(waitSaleOrder);
      setCountDeviceSaleOrder(cd)
    } catch (error) {
      console.log(error);
    }
  };

  return {
    onFetchCountReservation,
    countComplete,
    countNotConfirmChange,
    countWaitInvoice,
    countWaitSaleOrder,
    countDeviceSaleOrder
  };
};
